/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowchannelflyera64Inputs */

const en_aiflowchannelflyera64 = /** @type {(inputs: Aiflowchannelflyera64Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A6 flyer for print`)
};

const de_aiflowchannelflyera64 = /** @type {(inputs: Aiflowchannelflyera64Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flyer A6 zum Drucken`)
};

/**
* | output |
* | --- |
* | "A6 flyer for print" |
*
* @param {Aiflowchannelflyera64Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowchannelflyera64 = /** @type {((inputs?: Aiflowchannelflyera64Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowchannelflyera64Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowchannelflyera64(inputs)
	return de_aiflowchannelflyera64(inputs)
});
export { aiflowchannelflyera64 as "aiFlowChannelFlyerA6" }